import { store } from "@store/storeConfig/store";
// ** Initial State
const initialState = {
  allMaintenances: [],
  total: 1,
  params: {},
  customTotal: null,
  token: JSON.parse(localStorage.getItem("accessToken")),
  getError: false,
  errorMsg: "Error occured!!",
  otpSuccess: false,
  setNewPassword: false,
  found_results: "",
  entries_per_page: "",
  total_results: "",
  fetching: false,
  updatePagination: 0,
  isTokenExpire: false,
};
// console.log(store)

// console.log('sssssssssssss', selectedUser)

const maintenances = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_MAINTENANCE":
      return {
        ...state,
        allMaintenances: action.data,
        customTotal: action.total,
        entries_per_page: action.entries_per_page,
        found_results: action?.found_results,
        total_results: action?.total_results,
      };

    case "DELETE_MAINTENANCE":
      // console.log(action.data)
      return { ...state, allMaintenances: action.data };

    case "GET_ERROR":
      return { ...state, getError: true, errorMsg: action.error };
    case "REMOVE_ERROR":
      return { ...state, getError: false, errorMsg: "" };
    default:
      return { ...state };
  }
};
export default maintenances;
